import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import dayjs from "dayjs";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import { useNavigate } from "react-router-dom";
import utc from 'dayjs/plugin/utc'
import { AiFillEdit } from "react-icons/ai";
import { API_URL } from "../../config";
import Tooltip from "@mui/material/Tooltip";
import DatePicker from "../../components/Datapicker";
import { FaRegCalendarAlt, FaExclamationTriangle } from "react-icons/fa";
import { LuCircleCheck, LuCircleX } from "react-icons/lu";
import { Checkbox } from "@mui/material";
import { logAuditUI } from "../../utils/auditLogger";

dayjs.extend(utc);
dayjs.tz.guess();

function DashboardCard24report() {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const { item: initialData } = location.state || {};

  useEffect(() => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raportare',
      entityId: initialData?.planning_id,
      description: `A deschis raportarea planificării (ID: ${initialData?.planning_id || ''})`,
    });
  }, []);
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [user, setUser] = useState(null);
  const [open2, setOpen2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showGrid, setShowGrid] = useState(true);
  const [Data1, setData1] = useState([]);
  const [Data2, setData2] = useState([]);
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [defaultOption, setDefaultOption] = useState("");
  const [selectedUsers2, setSelectedUsers2] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [product, setProduct] = useState([]);
  const [coment, setComent] = useState('');
  const [comments, setComments] = React.useState({});
  const [searchQuery2, setSearchQuery2] = useState('');
  const [selecteddeleteuser1, setSelecteddeleteuser1] = useState(null);
  const getCurrentTime = () => dayjs.utc().hour(8).minute(30).second(0).millisecond(0).format();
  const [startTime, setStartTime] = useState(getCurrentTime());
  const [endTime, setEndTime] = useState(getCurrentTime());
  const [defaultOption1, setDefaultOption1] = useState([]);
  const [defaultOption2, setDefaultOption2] = useState([]);
  const [startDate1, setStartDate1] = useState(getCurrentDate());
  const [product1, setProduct1] = useState([]);
  const [searchQuery3, setSearchQuery3] = useState('');
  const [selectedUsers3, setSelectedUsers3] = useState([]);
  const [showff, setShowff] = useState(false);
  const token = localStorage.getItem('jwtToken');
  const [survey, setSurvey] = useState([]);
  const [anssurvey, setansSurvey] = useState([]);
  const [anssurvey2, setansSurvey2] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  const [isPresent, setisPresent] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/surveyquestions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log(user)
        if (user && user.brand_type_id === 3) {
        }
        setSurvey(response.data)

      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, [user]);

  const handleSurveyAnswer = (survey_questions_id, answer) => {
    const numericValue = answer === 'Da' ? 1 : 0;

    setansSurvey(prev => {
      const filtered = prev.filter(item => item.survey_questions_id !== survey_questions_id);
      return [...filtered, { survey_questions_id, survey_answer: numericValue }];
    });

    setSurvey(prevSurvey =>
      prevSurvey.map(item =>
        item.survey_questions_id === survey_questions_id
          ? { ...item, answer }
          : item
      )
    );
  };

  useEffect(() => {
    const hasSpecialAnswer1 = anssurvey.some(item =>
      (item.survey_questions_id === 10 || item.survey_questions_id === 21) &&
      item.survey_answer === 1
    );

    if (hasSpecialAnswer1) {
      setansSurvey2(true)
    } else {
      setansSurvey2(false)
    }
  }, [anssurvey]);

  useEffect(() => {
    console.log(defaultOption2)
  }, [defaultOption2]);

  useEffect(() => {
    if (user?.userId) {
      const timer = setTimeout(() => {
        setShowGrid(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user?.userId]);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setDefaultOption(decoded.userId)
        setUser(decoded);
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  useEffect(() => {
    if (!user?.userId || !selectedEditRowData) return;
    console.log(selectedEditRowData)
    const formattedDatestart = dayjs
      .utc(selectedEditRowData?.date || selectedEditRowData?.start)
      .format("YYYY-MM-DD");

    setStartDate(formattedDatestart);

    const fetchData = async () => {
      try {
        const rep = await axios.post(
          `${API_URL}/api/planreport`,
          { user_id: user.userId, date: formattedDatestart },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const response = await axios.post(`${API_URL}/api/planning/details`, {
          planning_id: selectedEditRowData?.planning_id, planning_detail_id: selectedEditRowData?.planning_detail_id
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const val = rep.data;
        let baseTime = startTime;
        if (val.length > 0) {
          const sortedItems = val.sort(
            (a, b) => b.report_detail_id - a.report_detail_id
          );
          const lastItem = sortedItems[0];
          const lastEnd = new Date(lastItem.end_time);
          lastEnd.setMinutes(lastEnd.getMinutes() + 10);
          baseTime = lastEnd.toISOString();
        }

        const details = response.data.data[0]?.plannings[0]?.days[0]?.details;

        const medica_agent_adress_id = response.data.data[0]?.plannings[0]?.days[0]?.details[0].location?.medica_agent_adress_id;
        if (medica_agent_adress_id) {
          const response = await axios.post(`${API_URL}/api/pharmacistff`, {
            medica_agent_adress_id: medica_agent_adress_id
          }, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
          setProduct1(response.data);
        }

        if (details && Array.isArray(details)) {

          if (selectedEditRowData.location?.id_inst === 1058 || details[0].location?.id_inst === 1058) {
            setShowff(true);
          }
          const formattedData = details.map((item, index) => {
            const startOffset = index * 20;
            const endOffset = startOffset + 20;

            const newStartTime = new Date(baseTime);
            newStartTime.setMinutes(newStartTime.getMinutes() + startOffset);

            const newEndTime = new Date(baseTime);
            newEndTime.setMinutes(newStartTime.getMinutes() + endOffset);

            return {
              start_time: newStartTime.toISOString(),
              end_time: newEndTime.toISOString(),
              obiect_id: item?.object_id ?? null,
              index: index + 1,
              obiect_type_id: item?.obiect_type_id ?? null,
              comment: item?.comment ?? "",
              planning_detail_id: item?.planning_detail_id ?? null,
              institution_id: item?.location?.institution_id ?? null,
              institution: item?.location?.institution ?? null,
              address: item?.location?.address ?? null,
              city_name: item?.location?.city ?? null,
              inst_type: item?.location?.inst_type ?? null,
              physician_name: item?.physician?.name ?? null,
              data_acord: item?.physician?.data_acord ?? null,
              speciality: item?.physician?.speciality ?? null,
              is_double_visit: item?.is_double_visit ?? null,
            };
          });

          console.log(formattedData)
          setData2(formattedData);
        } else {
          console.error("Structura de date neașteptată:", response.data);
          setData2([]);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [selectedEditRowData, user, token]);

  useEffect(() => {
    if (!user?.userId) return;

    const fetchMaterials = axios.get(`${API_URL}/api/materials`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const fetchProduct = axios.post(
      `${API_URL}/api/productuser`,
      { user_id: user?.userId || 0 },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const fetchManageUsers = axios.post(
      `${API_URL}/api/users/manageusers`,
      { user_id: user?.userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Promise.all([fetchMaterials, fetchProduct, fetchManageUsers,])
      .then(([materialsRes, productRes, manageUsersRes]) => {
        const materials = materialsRes.data.filter((i) => i.is_active !== 0);
        setMaterials(materials);
        setProduct(productRes.data);
        setData1(manageUsersRes.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [user, token]);

  useEffect(() => {
    if (selecteddeleteuser1) {
      handleOpenRows2();
    }
  }, [selecteddeleteuser1]);

  const handleOpenRows2 = () => {
    setOpen2(true);
    const startTimeFormatted = dayjs.utc(selecteddeleteuser1.start_time);
    const endTimeFormatted = dayjs.utc(selecteddeleteuser1.end_time);
    setStartTime(startTimeFormatted);
    setEndTime(endTimeFormatted);
  };

  const handleToggleUser2 = (userId) => {
    setSelectedUsers2((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleToggleUser3 = (userId) => {
    setSelectedUsers3((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleSave2 = async () => {
    setData2((prevData) => {
      const updatedData = prevData.map((entry) => {
        if (entry.index === selecteddeleteuser1.index) {
          const newStartTime = startTime;
          const newEndTime = endTime;

          return {
            ...entry,
            start_time: newStartTime,
            end_time: newEndTime,
          };
        }
        return entry;
      });
      return updatedData;
    });

    setSelecteddeleteuser1("");
    setOpen2(false);
  };

  const handleButtonClick2 = async () => {
    setIsLoading(true);
    try {
      handleSave2();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    try {
      const requests = Data2.map((item) => ({
        start_time: item.start_time,
        end_time: item.end_time,
        comment: coment,
        planning_detail_id: item.planning_detail_id,
        user_id: defaultOption || user.userId,
        visit_date: startDate,
        planning_id: selectedEditRowData.planning_id,
        physician_is_present: isPresent
      }));

      if (requests.length === 0) return handleSuccess();

      const rep = await axios.post(`${API_URL}/api/reportdetail`, requests);

      const reportDetailIds = rep.data.report_detail_ids;

      const allRequests1 = [];
      const allRequests2 = [];
      const allRequests3 = [];
      const allRequests4 = [];
      const allRequests5 = [];
      reportDetailIds.forEach((reportDetailId) => {
        if (defaultOption1?.length) {
          allRequests1.push(...defaultOption1.map(id => ({
            materials_id: id,
            report_detail_id: reportDetailId,
            is_active: 1,
            user_id: user?.userId,
            planning_id: selectedEditRowData.planning_id

          })));
        }

        if (selectedUsers2?.length) {
          allRequests2.push(...selectedUsers2.map(id => ({
            product_id: id,
            report_detail_id: reportDetailId,
            is_active: 1,
            user_id: user?.userId,
            planning_id: selectedEditRowData.planning_id
          })));
        }
        if (defaultOption2?.length) {
          const defaultOption2filter = defaultOption2?.filter((i) => i != user?.userId)

          //  if (defaultOption2?.length && !defaultOption2.includes(user?.userId)) {
          if (defaultOption2filter?.length) {
            allRequests3.push(...defaultOption2.map(id => ({
              user_id: id,
              report_detail_id: reportDetailId,
              is_active: 1,
              submiteduser_id: user?.userId,
              planning_id: selectedEditRowData.planning_id
            })));
          }
        }

        if (selectedUsers3?.length) {
          allRequests4.push(...selectedUsers3.map(id => ({
            pharmacist_id: id,
            report_detail_id: reportDetailId,
            planning_id: selectedEditRowData.planning_id,
            submiteduser_id: user?.userId,
          })));
        }

        if (anssurvey?.length) {
          const surveyPayload = anssurvey
            .map(ans => ({
              survey_questions_id: ans.survey_questions_id,
              report_detail_id: reportDetailId,
              planning_id: selectedEditRowData.planning_id,
              submiteduser_id: user?.userId,
              survey_answer: (ans.survey_answer === 'Da' || ans.survey_answer === 1) ? 1 : 0,
              comment: comments[ans.survey_questions_id] || null
            }));
          allRequests5.push(...surveyPayload);
        }


      });

      await Promise.all([

        allRequests1.length > 0 && axios.post(`${API_URL}/api/reportmaterials`, allRequests1),
        allRequests2.length > 0 && axios.post(`${API_URL}/api/reportproducts`, allRequests2),
        allRequests3.length > 0 && axios.post(`${API_URL}/api/reportdoublevisits`, allRequests3),
        allRequests4.length > 0 && axios.post(`${API_URL}/api/reportpharmacistff`, allRequests4),
        allRequests5.length > 0 && axios.post(`${API_URL}/api/surveyanswers`, allRequests5),
      ]);

      if (allRequests3.length > 0) {
        axios.put(`${API_URL}/api/updateplanningdetail`, {
          planning_detail_id: requests[0].planning_detail_id
        });
      }

      handleSuccess();
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    let selectedDate = new Date();

    const handleDateChange = (e) => {
      const dateString = e.target.value;
      const dateObj = new Date(dateString);

      if (!isNaN(dateObj.getTime())) {
        selectedDate = dateObj;
      } else {
        console.error("Invalid date input:", dateString);
      }
    };

    if (anssurvey2 === true) {
      showToast({
        message: (
          <div>
            <p className="font-medium">Doriți să înregistrați acest medic pentru o altă zi?</p>
            <div className="flex gap-2 mt-2">
              <button
                className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white flex items-center gap-2"
                onClick={() => {
                  showToast({
                    message: (
                      <div>
                        <p>Alegeți data pentru următoarea înregistrare:</p>
                        <DatePicker
                          selected={selectedDate}
                          handleDateChange={handleDateChange}
                        />
                        <div className="flex justify-end gap-2 mt-3">
                          <button
                            className="px-3 py-1 bg-gray-800 text-white rounded-md"
                            onClick={() => {
                              handlePlaning(selectedDate)
                            }}
                          >
                            Salvează
                          </button>
                          <button
                            className="bg-gray-200 text-gray-800 px-3 py-1 rounded"
                            onClick={() => {
                              handleClose();
                              showToast({
                                message: "Datele au fost salvate cu succes!",
                                type: "success",
                                icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
                              });
                            }}
                          >
                            Anulează
                          </button>
                        </div>
                      </div>
                    ),
                    type: "info",
                    icon: <FaRegCalendarAlt className="text-blue-500" />,
                  });
                }}
              >
                Da
              </button>

              <button
                className="px-3 py-1 bg-gray-200 text-gray-800 rounded-md"
                onClick={() => {
                  handleClose();
                  showToast({
                    message: "Datele au fost salvate cu succes!",
                    type: "success",
                    icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
                  });
                }}
              >
                Nu
              </button>
            </div>
          </div>
        ),
        type: "warning",
        icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
      });
    }
    else {
      handleClose();
      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    }
  };

  const handlePlaning = async (selectedDate1) => {
    try {
      const formattedDate = new Date(selectedDate1).toISOString().split('T')[0];
      const userId = user?.userId || selectedEditRowData?.user_id;

      if (!userId) {
        throw new Error("No user ID available");
      }

      const response = await axios.get(`${API_URL}/api/planningdatecheck`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          user_id: userId,
          date: formattedDate
        }
      });

      const val = response.data;

      if (val.length > 0) {
        const planingDayId = val[0].planning_day_id;
        const planning_id = val[0].planning_id[0];

        let requests = [];
        const dataToProcess = Array.isArray(selectedEditRowData)
          ? selectedEditRowData
          : [selectedEditRowData];

        if (dataToProcess.length > 0) {
          requests = dataToProcess.map((dataForPlanning) => ({
            planning_day_id: planingDayId,
            obiect_type_id: selectedEditRowData.obiect_type_id,
            object_id: dataForPlanning.object_id,
            activity_type_id: 1,
            submited_user_id: user.userId,
            planning_id: planning_id
          })).filter(Boolean);
        }

        if (requests.length > 0) {
          await axios.post(`${API_URL}/api/planningdetail`, requests);
        }
      } else {
        const planningResponse = await axios.post(`${API_URL}/api/planning`, {
          date: formattedDate,
          user_id: user.userId,
          start_date: selectedDate1,
          end_date: selectedDate1,
          submited_user_id: user.userId,
          planning_type_id: 1
        });

        const lastPlanningId = planningResponse.data.planning_id;

        const dateArray = [selectedDate1]

        const daysResponse = await axios.post(`${API_URL}/api/planningday`, {
          dates: dateArray,
          planning_id: lastPlanningId,
          submited_user_id: user.userId,
        });

        const filter = daysResponse.data.planning_day_ids[0];

        const dataToProcess = Array.isArray(selectedEditRowData)
          ? selectedEditRowData
          : [selectedEditRowData];

        let requests;

        if (dataToProcess.length > 0) {
          requests = dataToProcess.map((dataForPlanning) => ({
            planning_day_id: filter,
            obiect_type_id: selectedEditRowData.obiect_type_id,
            object_id: dataForPlanning.object_id,
            activity_type_id: 1,
            submited_user_id: user.userId,
            planning_id: lastPlanningId
          })).filter(Boolean);
        }

        if (requests.length > 0) {
          await axios.post(`${API_URL}/api/planningdetail`, requests);
        }
      }

      showToast({
        message: "Planning saved successfully!",
        type: "success"
      });

      handleClose();

    } catch (error) {
      console.error("Error in handlePlaning:", error);
      showToast({
        message: error.response?.data?.message || "Failed to save planning",
        type: "error"
      });
    }
  };

  const handleClose = () => {
    navigate(-1);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const dropdownOptions = Data1.map((region) => ({
    value: region.user_id,
    label: region.user_name_surname
  }));

  const _onSelect = (selectedOption) => {
    setDefaultOption(selectedOption);
  };

  const dropdownOptions1 = materials.map((region) => ({
    value: region.materials_id,
    label: region.description
  }));

  const _onSelect1 = (value, isChecked) => {
    if (isChecked) {
      setDefaultOption1((prev) => [...prev, value]);
    } else {
      setDefaultOption1((prev) => prev.filter((item) => item !== value));
    }
  };

  const _onSelect2 = (value, isChecked) => {
    if (isChecked) {
      setDefaultOption2((prev) => [...prev, value]);
    } else {
      setDefaultOption2((prev) => prev.filter((item) => item !== value));
    }
  };

  const handleStartTimeChange = (e) => {
    const selected = e.target.value;
    const today = dayjs().format("YYYY-MM-DD");
    const newStartUTC = dayjs.utc(`${today}T${selected}`).toISOString();

    if (endTime &&
      dayjs.utc(newStartUTC).isAfter(dayjs.utc(endTime).subtract(5, "minute"))
    ) {
      const bumpedEnd = dayjs.utc(newStartUTC).add(5, "minute").toISOString();
      setEndTime(bumpedEnd);
    }

    setStartTime(newStartUTC);
  };

  const handleEndTimeChange = (e) => {
    const selected = e.target.value;
    const today = dayjs().format("YYYY-MM-DD");
    const newEndUTC = dayjs.utc(`${today}T${selected}`).toISOString();

    if (startTime && dayjs.utc(newEndUTC).isBefore(dayjs.utc(startTime))) {
      setErrorMessage(`Ora de sfârșit nu poate fi mai mică decât ora de start (${dayjs.utc(startTime).format('HH:mm')})`);
      setShowError(true);
      setEndTime(newEndUTC);
    } else {
      setEndTime(newEndUTC);
      setShowError(false);
    }
  };

  const handleChangecom = useCallback((event) => {
    setComent(event.target.value);
  }, []);


  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <div className="col-span-full  rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Formular" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                  action={user.role !== 'User' && (
                    <div className="relative mt-4">
                      <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10">Utilizator</label>
                      <select
                        className="w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                        value={defaultOption}
                        onChange={(e) => _onSelect(e.target.value)}
                        disabled={true}

                      >
                        <option value="" disabled>Alege utilizator</option>
                        {dropdownOptions.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                  )} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex gap-2 ">
                      <div className="relative w-full">
                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                          Perioada: Data
                        </label>
                        <DatePicker
                          selectedDate={startDate}
                          handleDateChange={handleStartDateChange}
                          toDate={dayjs(startDate1).toDate()}
                        />
                      </div>

                    </div>
                  </div>

                  <div className="relative mt-4">
                    <Divider className="dark:bg-gray-400" />
                    <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
                      <h2 className="font-semibold text-gray-800 dark:text-gray-100">Raportare detalii</h2>
                      <h2 className="font-medium text-gray-600 dark:text-gray-300">
                        {Data2[0]?.is_double_visit ? 'Vizita Dubla' : null}
                      </h2>
                    </header>

                    <div className="p-3 max-xs:sr-only">
                      <div className="lg:flex w-full">
                        <div className="w-full overflow-x-auto">
                          <table className="w-full table-auto whitespace-nowrap">
                            <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                              <tr>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Interval ora</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Doctor</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Specialitatea</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Tip</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Institutia</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Adresa</div>
                                </th>
                                <th className="p-2">
                                  <div className="font-semibold text-left">Oras</div>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                              {Data2.map((item, idx) => {

                                return (
                                  <React.Fragment key={idx}>
                                    <tr className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                      <td className="p-2 whitespace-nowrap flex items-center">
                                        {item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                          ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                            <span>{item.start_time} - {item.end_time}</span>)}
                                        <div
                                          className="font-semibold text-center"
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: "20px",
                                          }}
                                        >
                                          <Tooltip title="Editeaza" arrow placement="top">
                                            <IconButton
                                              onClick={() => setSelecteddeleteuser1(item)}
                                              color="primary"
                                              sx={{
                                                fontSize: "16px",
                                                borderRadius: "50%",
                                                "&:hover": {
                                                  backgroundColor: "#a4adad",
                                                },
                                              }}
                                            >
                                              <AiFillEdit className="dark:text-gray-100" />

                                            </IconButton>
                                          </Tooltip>
                                          <Transition appear show={open2} as={Fragment}>
                                            <Dialog as="div" className="relative z-10" onClose={() => setOpen2(false)}>
                                              <Transition.Child
                                                as={Fragment}
                                                enter="ease-out duration-300"
                                                enterFrom="opacity-0"
                                                enterTo="opacity-100"
                                                leave="ease-in duration-200"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                              >
                                                <div className="fixed inset-0 bg-black bg-opacity-25" />
                                              </Transition.Child>

                                              <div className="fixed inset-0 overflow-y-auto">
                                                <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                  <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0 scale-95"
                                                    enterTo="opacity-100 scale-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100 scale-100"
                                                    leaveTo="opacity-0 scale-95"
                                                  >
                                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                      <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                                        Selectează Ora
                                                      </Dialog.Title>
                                                      <div className="mt-4">
                                                        <form className="max-w-[16rem] mx-auto grid grid-cols-2 gap-4">
                                                          <div>
                                                            <label htmlFor="start-time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                              Start ora:
                                                            </label>
                                                            <div className="relative">
                                                              <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                                                                <svg
                                                                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                  aria-hidden="true"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  fill="currentColor"
                                                                  viewBox="0 0 24 24"
                                                                >
                                                                  <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd" />
                                                                </svg>
                                                              </div>
                                                              <input
                                                                type="time"
                                                                id="start-time"
                                                                className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                value={startTime ? dayjs.utc(startTime, "HH:mm").format("HH:mm") : ""}
                                                                onChange={handleStartTimeChange}
                                                                name="appt"
                                                                // min="09:00" 
                                                                // max={maxStart}
                                                                required />
                                                            </div>
                                                          </div>
                                                          <div>
                                                            <label htmlFor="end-time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                              End ora:
                                                            </label>
                                                            <div className="relative">
                                                              <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                                                                <svg
                                                                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                  aria-hidden="true"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  fill="currentColor"
                                                                  viewBox="0 0 24 24"
                                                                >
                                                                  <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd" />
                                                                </svg>
                                                              </div>
                                                              <input
                                                                type="time"
                                                                id="end-time"
                                                                className={`bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${showError ? 'border-red-500' : ''
                                                                  }`} value={endTime ? dayjs.utc(endTime, "HH:mm").format("HH:mm") : ""}
                                                                // min={minEnd}
                                                                onChange={handleEndTimeChange}
                                                                required />
                                                            </div>
                                                          </div>
                                                        </form>
                                                        {showError && (
                                                          <p className="mt-1 text-sm text-red-600 flex items-center">
                                                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                            </svg>
                                                            {errorMessage}
                                                          </p>
                                                        )}
                                                      </div>

                                                      <div className="mt-4 flex justify-end gap-2">
                                                        <button
                                                          className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                          onClick={() => { setOpen2(false), setSelecteddeleteuser1("") }}
                                                        >
                                                          Anulează
                                                        </button>

                                                        <button
                                                          className={`btn ${isLoading
                                                            ? "bg-gray-500 text-gray-300"
                                                            : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                          onClick={handleButtonClick2}
                                                          disabled={isLoading}
                                                        >
                                                          {isLoading ? (
                                                            <svg
                                                              className="animate-spin fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <circle
                                                                className="opacity-25"
                                                                cx="8"
                                                                cy="8"
                                                                r="7"
                                                                stroke="currentColor"
                                                                strokeWidth="2" />
                                                              <path
                                                                className="opacity-75"
                                                                d="M12 2a6 6 0 000 12V2z" />
                                                            </svg>
                                                          ) : (
                                                            <svg
                                                              className="fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                            </svg>
                                                          )}
                                                          <span className="//max-xs:sr-only">
                                                            {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </Dialog.Panel>
                                                  </Transition.Child>
                                                </div>
                                              </div>
                                            </Dialog>
                                          </Transition>
                                        </div>
                                      </td>
                                      <td className="p-2 whitespace-nowrap">
                                        {item.obiect_type_id === 1 ? (
                                          <div className="flex items-center gap-1.5">
                                            <span>{item.physician_name || "-"}</span>
                                            {item.data_acord ? (
                                              <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                </svg>
                                              </span>
                                            ) : null}
                                          </div>
                                        ) : "-"}
                                      </td>
                                      <td className="p-2 whitespace-nowrap">{item.obiect_type_id === 1 ? item.speciality || "-" : "-"}</td>
                                      <td className="p-2 whitespace-nowrap">{item.inst_type}</td>
                                      <td className="p-2 whitespace-nowrap">{item.institution}</td>
                                      <td className="p-2 whitespace-nowrap">{item.address}</td>
                                      <td className="p-2 whitespace-nowrap">{item.city_name}</td>
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <table className="w-full">
                      <tbody>
                        {Data2.map((item, idx) => {
                          return (
                            <React.Fragment key={idx}>
                              <tr>
                                <td>
                                  <div className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700">
                                    <div className="grid grid-cols-1 gap-2">
                                      <div className="flex items-center gap-2 p-2">
                                        <div>
                                          <div className="flex items-center justify-between">
                                            <span className="text-gray-600 dark:text-gray-300">Interval ora: </span>
                                            {item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                              ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                <span>{item.start_time} - {item.end_time}</span>)}
                                            <div
                                              className="font-semibold text-center"
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "20px",
                                              }}
                                            >
                                              <Tooltip title="Editeaza" arrow placement="top">
                                                <IconButton
                                                  onClick={() => setSelecteddeleteuser1(item)}
                                                  color="primary"
                                                  sx={{
                                                    fontSize: "16px",
                                                    borderRadius: "50%",
                                                    "&:hover": {
                                                      backgroundColor: "#a4adad",
                                                    },
                                                  }}
                                                >
                                                  <AiFillEdit className="dark:text-gray-100" />

                                                </IconButton>
                                              </Tooltip>
                                            </div>
                                          </div>

                                          <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                            {item.obiect_type_id === 1 ? (
                                              <>
                                                <span>{item.physician_name}</span>
                                                {item.data_acord ? (
                                                  <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                    </svg>
                                                  </span>
                                                ) : null}
                                              </>
                                            ) : item.institution}
                                          </h3>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {item.inst_type}
                                          </div>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {item.obiect_type_id === 1 ? (item.speciality + " - " + item.institution) || "-" : null}
                                          </div>

                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                            {(item.address + " - " + item.city_name) || "-"}
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>

                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          <div className="flex-1  rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Participanți la vizită" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative space-y-2 mt-4 max-h-[220px] overflow-y-auto">
                    {dropdownOptions.map((option) => (
                      <div key={option.value} className="flex items-center  ml-4">
                        <input
                          type="checkbox"
                          id={option.value}
                          value={option.value}
                          checked={defaultOption2.includes(option.value)}
                          onChange={(e) => _onSelect2(option.value, e.target.checked)}
                          className="ml-2 mr-2" />
                        <label htmlFor={option.value} className="text-sm">{option.label}</label>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>

          <div className="flex-1 rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Materiale" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    {dropdownOptions1.map((option) => (
                      <div key={option.value} className="flex items-center">
                        <input
                          type="checkbox"
                          id={option.value}
                          value={option.value}
                          checked={defaultOption1.includes(option.value)}
                          onChange={(e) => _onSelect1(option.value, e.target.checked)}
                          className="mr-2" />
                        <label htmlFor={option.value} className="text-sm">{option.label}</label>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>



          {(Data2[0]?.obiect_type_id === 2 && showff === true) && (
            <div className="flex-2 rounded-xl ">
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                }}
              >
                <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                  <CardHeader subheader="Informatia poate fii modificata" title="Cadre instruite FF" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                  <Divider className="dark:bg-gray-400" />
                  <CardContent>
                    <div className="relative mt-4">
                      <div className="mt-2">
                        <input
                          type="text"
                          className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                          placeholder="Căutare Farmacist"
                          value={searchQuery3}
                          onChange={(e) => setSearchQuery3(e.target.value)} />
                      </div>

                      <div className="mt-4 max-h-[164px] overflow-y-auto">
                        <ul>
                          {product1.filter((user) => {
                            return (
                              user.user_name_surname.toLowerCase().includes(searchQuery3.toLowerCase()) ||
                              user.description.toLowerCase().includes(searchQuery3.toLowerCase())
                            );
                          }).map((user) => {
                            return (
                              <li key={user.pharmacist_id} className="flex items-center gap-2 p-2 border-b">
                                <input
                                  type="checkbox"
                                  className="h-4 w-4"
                                  checked={selectedUsers3.includes(user.pharmacist_id)}
                                  onChange={() => handleToggleUser3(user.pharmacist_id, "physician")} />
                                <div>
                                  <div className="pl-4 flex flex-col">
                                    <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                      <span>{user.user_name_surname}</span>
                                      {(user.data_acord === 1 || user.data_acord === true) && (
                                        <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                          <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      )}
                                    </h3>
                                    <p className="text-sm text-gray-600 dark:text-gray-200">{user.description}</p>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </form>
            </div>
          )}

          <div
            className={`${(Data2[0]?.obiect_type_id === 2 && showff === true) ? 'flex-1 col-span-full rounded-xl' : 'flex-1 rounded-xl'}`}
          >
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Produse" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    <div className="mt-4">
                      <input
                        type="text"
                        className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                        placeholder="Căutare Produs"
                        value={searchQuery2}
                        onChange={(e) => setSearchQuery2(e.target.value)} />
                    </div>

                    <div className="mt-4 max-h-[164px] overflow-y-auto">
                      <ul>
                        {product.filter((user) => {
                          return (
                            user.description.toLowerCase().includes(searchQuery2.toLowerCase())
                          );
                        }).map((user, index) => {
                          return (
                            <li key={`${user.product_id}-${user.user_id}-${index}`} className="flex items-center gap-2 p-2 border-b">
                              <input
                                type="checkbox"
                                className="h-4 w-4"
                                checked={selectedUsers2.includes(user.product_id)}
                                onChange={() => handleToggleUser2(user.product_id, "physician")} />
                              <div>
                                <div className="pl-4 flex items-center justify-between">
                                  <h3 className="text-gray-900 dark:text-gray-100">{user.description}</h3>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>


          <div className="col-span-full rounded-xl">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader
                  subheader="Informatia poate fii modificata"
                  title="Chestionar"
                  subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    <div className="relative mt-2 overflow-y-auto">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm sticky top-0">
                          <tr>
                            <th scope="col" className="text-left p-2 font-semibold">Întrebare</th>
                            <th scope="col" className="text-center p-2 font-semibold">Da</th>
                            <th scope="col" className="text-center p-2 font-semibold">Nu</th>
                          </tr>
                        </thead>
                        <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                          {survey
                            .filter((i) => i.survey_questions_type_id === (Data2[0]?.obiect_type_id === 1 ? 1 : 2))
                            .map((user, idx) => (
                              <React.Fragment key={user.survey_questions_id}>
                                <tr className={`text-sm ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                  <td className="px-4 py-1 whitespace-normal">
                                    <p className="text-sm text-gray-600 dark:text-gray-200">{user.survey_questions}</p>
                                    {(user.survey_questions_id === 11 || user.survey_questions_id === 27 || user.survey_questions_id === 29 || user.survey_questions_id === 23) && (
                                      <p className="text-xs text-gray-500 dark:text-gray-300">
                                        Dacă ați selectat „Da”, completați caseta cu un comentariu.
                                      </p>
                                    )}
                                  </td>
                                  <td className="px-4 py-1 text-center">
                                    <button
                                      onClick={() => handleSurveyAnswer(user.survey_questions_id, 'Da')}
                                      className={`p-1 rounded-full ${user.answer === 'Da' ? 'text-green-500' : 'text-gray-300 dark:text-gray-600'}`}
                                      aria-label="Select Da"
                                    >
                                      <LuCircleCheck className="h-5 w-5" />
                                    </button>
                                  </td>
                                  <td className="px-4 py-1 text-center">
                                    <button
                                      onClick={() => handleSurveyAnswer(user.survey_questions_id, 'Nu')}
                                      className={`p-1 rounded-full ${user.answer === 'Nu' ? 'text-red-500' : 'text-gray-300 dark:text-gray-600'}`}
                                      aria-label="Select Nu"
                                    >
                                      <LuCircleX className="h-5 w-5" />
                                    </button>
                                  </td>
                                </tr>

                                {(user.survey_questions_id === 11 || user.survey_questions_id === 27 || user.survey_questions_id === 29 || user.survey_questions_id === 23) && user.answer === 'Da' && (
                                  <tr>
                                    <td colSpan={3}>
                                      <form onSubmit={(e) => e.preventDefault()}>
                                        <Card className="p-0 dark:bg-gray-800 dark:text-gray-100">
                                          <CardContent className="p-0">
                                            <div className="relative">
                                              <textarea
                                                id="message"
                                                rows="2"
                                                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="Scrie aici..."
                                                value={comments[user.survey_questions_id] || ''}
                                                onChange={(e) =>
                                                  setComments(prev => ({
                                                    ...prev,
                                                    [user.survey_questions_id]: e.target.value
                                                  }))
                                                }
                                              />
                                            </div>
                                          </CardContent>

                                        </Card>
                                      </form>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardContent>
              </Card>


            </form>
          </div>

          <div className="col-span-full rounded-xl ">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                <CardHeader subheader="Informatia poate fii modificata" title="Comentariu" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                <Divider className="dark:bg-gray-400" />
                <CardContent>
                  <div className="relative mt-4">
                    <textarea
                      id="message"
                      rows="2"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Scrie aici..."
                      value={coment}
                      onChange={handleChangecom} />
                  </div>
                </CardContent>
                <Divider className="dark:bg-gray-400" />
                <CardActions sx={{ justifyContent: 'flex-end' }}>
                  {Data2[0]?.obiect_type_id === 1 && (
                    <div className="text-left flex flex-row items-center">
                      <h2 className="font-medium text-gray-600 dark:text-gray-300">Doctorul a fost prezent</h2>

                      <Checkbox
                        checked={isPresent}
                        onChange={() => setisPresent(!isPresent)}
                        sx={{
                          color: isPresent ? "#10b981" : "#9ca3af",
                          '&.Mui-checked': {
                            color: "#10b981",
                          },
                          '&:hover': {
                            backgroundColor: "rgba(16, 185, 129, 0.1)",
                          },
                          padding: "4px",
                        }}
                      />
                    </div>)
                  }
                  <button
                    className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white flex items-center gap-2"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                      </svg>
                    ) : (
                      <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                    )}
                    <span className="//max-xs:sr-only">{loading ? "Se salvează..." : "Salvează detaliile"}</span>
                  </button>
                </CardActions>
              </Card>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default DashboardCard24report;